import { InnerBox } from "@/components/elements/InnerBox";
import { Grid, Typography } from "@mui/material";
import { FC } from "react";
import { TLearnerForm } from "@/features/learner/types/learnerForm";
import { findLabelByValue } from "@/utils/object";
import { useEnum } from "@/api/services/global/enum";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { useGetLearnerSchema } from "@/features/learner/hook/useGetLearnerSchema";

type TLearnerBasicInfoDetailProps = {
  data?: Partial<TLearnerForm>;
};

export const LearnerBasicInfoDetail: FC<TLearnerBasicInfoDetailProps> = ({ data }) => {
  const { data: genderOptions } = useEnum("EGender");
  const { isRsoUser } = useGetLearnerSchema();

  return (
    <InnerBox
      title={<Typography variant="head20Bold">基本情報</Typography>}
      showDivider={false}
    >
      <Grid container rowSpacing={2} columnSpacing={3}>
        {isRsoUser &&
          <Grid item xs={12}>
            <ItemInfo label="所属機関" value={data?.rsoCompany?.companyName} required />
          </Grid>
        }
        <Grid item xs={6}>
          <ItemInfo label="氏名" value={data?.fullName} required />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo label="呼び名" value={data?.nickName} />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo label="国籍" value={data?.nationality?.nationalityName} required />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo label="性別" value={findLabelByValue(genderOptions, data?.gender)} required />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo label="居住地　都道府県" value={data?.prefecture} />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo label="市区町村" value={data?.city} />
        </Grid>
      </Grid>
    </InnerBox>
  );
};
